export const SALE_TARGET = {
  BASE_PATH: "/sale-target/",
  GET_ALL: "/sale-target",
  GET_ONE: "/sale-target/edit/",
  CREATE: "/sale-target/create",
  UPDATE: "/sale-target/update/",
  DELETE: "/sale-target/delete/",
  ADD_NEW_TITLE: "Add New Sale Target",
};
